import { delay } from 'redux-saga/effects';
import { getStore } from 'src/App';
import actions from 'src/redux/actions';

const dispatch = (action, isLoading = false) => {
  if (isLoading) {
    getStore().dispatch(actions.enableLoading());
  }
  getStore().dispatch(action);
};

export function* offLoading() {
  yield getStore().dispatch(actions.disableLoading());
}

export function* disableLoading() {
  yield delay(500);
  yield getStore().dispatch(actions.disableLoading());
}

export default dispatch;
